export default {"src":"/_next/static/media/person.852021ca.svg","height":21,"width":21};